import { Outlet } from "@tanstack/react-router";
import { PortalHeader } from "./PortalHeader";

/**
 * 门户布局(任务 0.2):PortalHeader + Outlet,页面底 #f4f5f5,min-h-screen。
 * 除落地首页(/)与管理后台(/admin)外,全部页面走此布局,顶栏全站统一。
 */
export function PortalLayout() {
  return (
    // padding-top 补偿 fixed 顶栏:桌面两行 160px / 移动一行 80px
    <div className="min-h-screen bg-portal-bg pt-20 portal:pt-40">
      <PortalHeader />
      <Outlet />
    </div>
  );
}
